import React, { useState, useEffect } from "react";
import { Flex } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";
import CustomReactSelect from "../../../general/form/CustomReactSelect";

const fundTypes = [
  {
    value: "Private Equity",
    label: "Private Equity",
    options: ["Buy-out", "Growth Capital", "Distressed Equity"],
  },
  {
    value: "Venture Capital",
    label: "Venture Capital",
    options: ["Early Stage", "Late Stage"],
  },
  {
    value: "Real Estate",
    label: "Real Estate",
    options: ["Core", "Core+", "Value-Add", "Opportunistic"],
  },
  {
    value: "Infrastructure",
    label: "Infrastructure",
    options: ["Core Infrastructure", "Value-Add Infrastructure"],
  },
  {
    value: "Private Debt",
    label: "Private Debt",
    options: [
      "Direct Lending",
      "Senior Secured",
      "Mezzanine Debt",
      "Distressed Debt",
    ],
  },
  {
    value: "Fund of Funds",
    label: "Fund of Funds",
    options: [
      "PE FoF",
      "VC FoF",
      "RE FoF",
      "Infrastructure FoF",
      "Private Debt FoF",
    ],
  },
];

const OnboardingStep21 = ({ handleChange }) => {

  const [selectedFundTypes, setSelectedFundTypes] = useState([]);
  const [selectedFundTypeOption, setSelectedFundTypeOption] = useState(null);
  const [fundTypeOptions, setFundTypeOptions] = useState([]);

  useEffect(() => {
    if (selectedFundTypes.length === 1) {
      const selectedFund = fundTypes.find(
        (type) => type.value === selectedFundTypes[0]
      );
      setFundTypeOptions(selectedFund ? selectedFund.options : []);
      setSelectedFundTypeOption(null); // Reset selected option for a fresh start
    } else {
      setFundTypeOptions([]);
      setSelectedFundTypeOption(null); // Clear the selected option when multiple fund types are selected
    }
  }, [selectedFundTypes]);

  // Handle fund type selection
  const handleFundTypeChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((opt) => opt.value)
      : [];
    setSelectedFundTypes(values);
    handleChange({ target: { name: "fundType", value: values } });
    setSelectedFundTypeOption(null); // Reset selected option whenever fund type changes
  };

  // Handle fund type option selection
  const handleFundTypeOptionChange = (selectedOption) => {
    setSelectedFundTypeOption(selectedOption);
    handleChange({
      target: {
        name: "fundTypeOption",
        value: selectedOption ? selectedOption.value : "",
      },
    });
  };


  return (
    <>
      <Flex direction="column" gap={8}>
        <h6>Fund Classification</h6>

        <Flex direction="column">
          <Fieldset
            label="Fund type"
            description="Select one or more fund types"
            input={
              <CustomReactSelect
                name="fundType"
                placeholder="Choose a fund type"
                options={fundTypes.map(({ value, label }) => ({
                  value,
                  label,
                }))}
                value={fundTypes.filter((type) =>
                  selectedFundTypes.includes(type.value)
                )}
                onChange={handleFundTypeChange}
                isMulti // Enables multiple selection
              />
            }
          />

          {/* Fund Type Options - Conditional Select */}
          <Fieldset
            label="Fund type options"
            description="Select an option for the chosen fund type"
            opacity={selectedFundTypes.length === 1 ? 1 : 0.5}
            pointerEvents={selectedFundTypes.length === 1 ? "auto" : "none"}
            input={
              <CustomReactSelect
                name="fundTypeOption"
                placeholder="Choose an option"
                options={fundTypeOptions.map((option) => ({
                  value: option,
                  label: option,
                }))}
                value={
                  selectedFundTypeOption
                    ? {
                        value: selectedFundTypeOption.value,
                        label: selectedFundTypeOption.label,
                      }
                    : null
                }
                onChange={handleFundTypeOptionChange}
                isDisabled={selectedFundTypes.length !== 1}
                key={selectedFundTypes[0]} // Force re-render based on selected fund type
              />
            }
          />

        </Flex>
      </Flex>
    </>
  );
};

export default OnboardingStep21;
